import React, { useEffect, useState } from "react";
import HorizontalCard from "../../components/card/HorizontalCard";
import PageBanner from "../../components/PageBanner";
import AppointmentService from "../../services/appointment";
import BannerService from "../../services/banner";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

export default function Appointment() {
  let [appointmentData, setAppointmentData] = useState([]);
  let [appointmentBanner, setAppointmentBanner] = useState([]);

  let { lang } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    getAppointmentData();
    getAppointmentBanner();
  }, []);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  const getAppointmentData = async () => {
    try {
      let res = await AppointmentService.getAppointment();
      setAppointmentData(res);
    } catch {
      console.error();
    }
  };

  const getAppointmentBanner = async () => {
    try {
      let res = await BannerService.getBanner(3);
      setAppointmentBanner(res);
    } catch {
      console.error();
    }
  };

  const history = useHistory();

  const bannerText = [{ name: "appointment", href: "/appointment" }];

  return (
    <div id="appointment" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th={"นัดหมาย"}
        text_en={"Appointment"}
        banner={appointmentBanner?.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          {/* นัดหมาย */}
          <div className="mt-[92px] mb-[300px]">
            <h1 className="text-heading font-bold text-slateGray text-left">
              {lang === "th" ? "นัดหมาย" : "Appointment"}
            </h1>
            <p className="text-lead text-left mt-[12px] font-normal">
              {lang === "th"
                ? "เลือกบริการที่ต้องการสร้างนัดหมาย"
                : "Select the service you want to create an appointment for."}
            </p>

            <div className="flex flex-col gap-[20px] mt-[38px]">
              {appointmentData &&
                appointmentData.map((item, i) => (
                  <div
                    key={i}
                    onClick={() => {
                      if (item.link.href && item.link.href !== "-")
                        history.push(`/${lang}/appointment${item.link.href}`);
                    }}
                  >
                    <HorizontalCard
                      data={item}
                      noDate={true}
                      appointment={true}
                      lang={lang}
                    />
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
